import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

export const Title = styled(Text).attrs({
  size: 'header',
  fontWeight: 'bold',
  mt: 20,
  mb: '10px',
  color: 'primaryText',
})``;

export const Description = styled(Text).attrs({
  size: 'normal',
  fontWeight: 'bold',
  color: 'primaryText',
})``;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-column-gap: 6px;
  margin-bottom: 10px;
`;
